<template>
    <div class="cp-barchart">
        <div class="cp3-barchart" v-if="series && options">
            <apexchart ref="barChart1" type="bar" :options="options" :series="series"></apexchart>
        </div>
    </div>
</template>

<script>
export default {
    mounted() {
        this.updateSeries();
    },
    props: ["chartOptions", "seriesData"],
    data() {
        return {
            series: [],
            options: {}
        };
    },
    methods: {
        updateSeries() {
            this.options = this.chartOptions;
            this.series = this.seriesData;
        }
    },
    watch: {
        chartOptions(val) {
            this.options = val;
        },
        seriesData(val) {
            this.series = val;
        }
    }
};
</script>

<style>
</style>